(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dastan-product-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dastan-product-story')) {
    customElements.define('dastan-product-story', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.dastan-story__trigger');
        if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.dialog.showModal();
          this.querySelector('.dastan-story__content').scrollTop = 0;
          document.documentElement.classList.add('dastan-story-open');
        }, options);
        this.querySelectorAll('[data-story-close]').forEach(button => {
          button.addEventListener('click', () => this.dialog.close(), options);
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.releaseScroll();
          if (this.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
        this.hidden = false;
      }
      releaseScroll() {
        if (!document.querySelector('.dastan-story__dialog[open]')) document.documentElement.classList.remove('dastan-story-open');
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.releaseScroll();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
